'use es6';

import { getSettings, createGetSettings } from '../api/WebinarAPI';
import * as CacheKeys from '../constants/CacheKeys';
import createSimpleCachedReferenceResolver from '../lib/createSimpleCachedReferenceResolver';
export const createWebinarSettingReferenceResolver = options => createSimpleCachedReferenceResolver(Object.assign({
  cacheKey: CacheKeys.WEBINAR_SETTINGS,
  createFetchData: createGetSettings,
  fetchData: getSettings
}, options));
export default createWebinarSettingReferenceResolver();